/**
 * @file SwitchRow.tsx
 * @description Переключатель с подписью и пояснением для панели «Счётчики и
 * cookie» (phase19.16, партия Р3г, v0.19.62; SB133 «Вебвизор», SB134 «Без
 * счётчиков показывать уведомление»). Вся строка — касание от 48 px;
 * пояснение связано с переключателем `aria-describedby`.
 * v0.19.65 (SB147): пояснение — текст или несколько строк (подсказка о
 * действии во внешнем кабинете под основным пояснением).
 */

import { useId, type ReactNode } from "react";

import { Switch } from "../../ui/switch";
import { FieldHint } from "../../ui/settings-groups";

interface Props {
  label: string;
  hint: ReactNode;
  checked: boolean;
  disabled?: boolean;
  onChange: (on: boolean) => void;
}

export function SwitchRow({ label, hint, checked, disabled = false, onChange }: Props) {
  const hintId = useId();
  return (
    <div className="flex min-w-0 flex-col">
      <label className="flex min-h-12 cursor-pointer items-center gap-3 has-[:disabled]:cursor-not-allowed">
        <Switch checked={checked} disabled={disabled} aria-describedby={hintId} onCheckedChange={(on) => onChange(on)} />
        <span className="type-body text-on-surface">{label}</span>
      </label>
      <FieldHint id={hintId} className="mt-0">
        {hint}
      </FieldHint>
    </div>
  );
}
